<template>
  <div class="dashboard-layout">
    <div class="dashboard-layout__main">
      <slot name="main"></slot>
    </div>
    <div class="dashboard-layout__sidebar">
      <slot name="sidebar"></slot>
    </div>
  </div>
</template>

<script setup></script>

<style scoped lang="scss">
@import '@/stylesheets/global';
</style>
